import { OrderDetails } from "../slices/cartSlice";
import { useDealerAccountInfo } from "./useDealerAccountInfo";

export const useCartName = (cart?: OrderDetails): string => {
  const dealer = useDealerAccountInfo();
  return `${dealer.dealerName}-${cart?.orderId}`;
};
